function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5134 26.7878C27.1883 26.7878 29.3566 24.5967 29.3566 21.8939C29.3566 19.1911 27.1883 17 24.5134 17C21.8386 17 19.6702 19.1911 19.6702 21.8939C19.6702 24.5967 21.8386 26.7878 24.5134 26.7878Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0054 33.9102C17.0651 31.6811 20.7415 30.4815 24.5135 30.4815C28.2855 30.4815 31.9619 31.6811 35.0216 33.9102",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8 25.3241C37.3882 25.3241 38.6757 24.0231 38.6757 22.4183C38.6757 20.8135 37.3882 19.5125 35.8 19.5125C34.2118 19.5125 32.9243 20.8135 32.9243 22.4183C32.9243 24.0231 34.2118 25.3241 35.8 25.3241Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5513 29.5188C31.3685 28.1977 33.5505 27.487 35.7891 27.487C38.0277 27.487 40.2098 28.1977 42.027 29.5188",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.227 25.3241C14.8152 25.3241 16.1027 24.0231 16.1027 22.4183C16.1027 20.8135 14.8152 19.5125 13.227 19.5125C11.6388 19.5125 10.3513 20.8135 10.3513 22.4183C10.3513 24.0231 11.6388 25.3241 13.227 25.3241Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4541 29.5187C17.6415 28.1964 15.4627 27.4847 13.227 27.4847C10.9914 27.4847 8.81258 28.1964 7 29.5187",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgCustomerGroups = function SvgCustomerGroups(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomerGroups, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-groups.745a9091.svg";
export { ForwardRef as ReactComponent };